'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _FossilFuelBondRisks = require('./FossilFuelBondRisks.css');

var _FossilFuelBondRisks2 = _interopRequireDefault(_FossilFuelBondRisks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FossilFuelBondRisks = (_dec = (0, _reactCssModules2.default)(_FossilFuelBondRisks2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FossilFuelBondRisks, _Component);

  function FossilFuelBondRisks(props) {
    (0, _classCallCheck3.default)(this, FossilFuelBondRisks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FossilFuelBondRisks.__proto__ || (0, _getPrototypeOf2.default)(FossilFuelBondRisks)).call(this, props));

    _this.state = {
      title: 'Financial risks of fossil fuel bonds',
      description: 'Fossil fuel stocks and bonds pose different risks to the climate, and face different financial risks.',
      url: _config2.default.domain + _config2.default.routes.eduCenterPlanAdmins
    };
    return _this;
  }

  (0, _createClass3.default)(FossilFuelBondRisks, [{
    key: 'render',
    value: function render() {
      // const img1 = require( '../../../static/images/millenial_employees.jpg' )
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'copy' },
            _react2.default.createElement(
              'h3',
              null,
              'Fossil fuel stocks and bonds pose different risks to the climate, and face different financial risks.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Climate-related financial risks are spread throughout the global economy. Governments, banks, businesses, developers, and investors face different risks as the planet warms. For 401(k) investors, most of the focus to date has been on the risks of investing in the stocks of high-carbon companies. To address this risk, more employers are adding sustainable stock funds to their retirement plan lineup. But there\'s a problem: retirement plans are still investing billions in fossil fuel bonds, which carry their own kind of climate risk.'
            ),
            _react2.default.createElement(
              'blockquote',
              { styleName: 'blockquote' },
              _react2.default.createElement(
                'div',
                { styleName: 'blockquote-quotes' },
                '\u201C'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { styleName: 'blockquote-text' },
                  'Instead of slowing down the decarbonization of the global economy, now is the time to accelerate the energy transition to a renewable energy future. Fossil fuels are a dead end \u2013 for our planet, for humanity, and yes, for economies.'
                ),
                _react2.default.createElement(
                  'cite',
                  { styleName: 'blockquote-cite' },
                  'United Nations Secretary-General Ant\xF3nio Guterres'
                )
              )
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Stocks and bonds'
            ),
            _react2.default.createElement(
              'p',
              null,
              'First, a primer:'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Buying ',
              _react2.default.createElement(
                'b',
                null,
                'stocks'
              ),
              ' (also called ',
              _react2.default.createElement(
                'b',
                null,
                'equity'
              ),
              ') means you own a fraction of a corporation, giving you a (small) voice in how the company is run. Most people are more concerned with the value of their shares rising over time, meaning they want to invest in companies that they think will succeed in the future.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'On the other hand, buying ',
              _react2.default.createElement(
                'b',
                null,
                'bonds'
              ),
              ' (also called ',
              _react2.default.createElement(
                'b',
                null,
                'debt'
              ),
              ' or ',
              _react2.default.createElement(
                'b',
                null,
                'fixed income'
              ),
              ') means you\u2019re lending money to some company or organization. Most bonds are issued by governments, mortgage-issuers, banks, and businesses. For example, companies issue bonds to pay for expansions to operations. Bonds pay you a steady stream over time, and eventually you get paid back in full for your initial investment as well.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Bond prices are less volatile than stock prices and are preferred by investors looking for safe harbors. This includes major financial institutions and large pension fund managers, but it can also include 401(k) investors, especially those closer in age to retirement.'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Risk to climate, risk to portfolio'
            ),
            _react2.default.createElement(
              'p',
              null,
              'What does this have to do with the climate?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Climate risk can be thought of in two ways: the risk that the climate will hurt your investments, and the risk that your investments will hurt the climate. These risks are different for stocks and bonds.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For 401(k) investors, the main financial risk of investing in high-carbon industries like fossil fuel energy and utilities are that those stocks might be worth less in the future. There\'s ',
              _react2.default.createElement(
                'b',
                null,
                'physical risk'
              ),
              ': impacts of the climate crisis might hurt their operations - think hurricanes hitting offshore drilling rigs and shutting down coastal refineries. And there\'s also ',
              _react2.default.createElement(
                'b',
                null,
                'transition risk'
              ),
              ': the clean energy transition might make their business models uncompetitive, or governments might regulate them, ordering them to reduce emissions, impacting profitability.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Every sector in a diversified portfolio faces risk of losses from rising temperatures, but high-carbon industries are acutely at risk, particularly from transition risks. The climate crisis is driven by emissions, and governments agree that emissions must be lowered. High-carbon business models are what we are transitioning away from. These industry-wide pressures are what long-term investors point to as many have pulled back from coal and oil & gas over the past decade.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The connection between stocks and emissions is diffuse. Critics of fossil free investing say most stocks are bought from other investors, not the company directly. If you sell your shares, there\'s little or no impact on the company, and now someone else is the "owner" of that company, maybe someone who cares less about climate change than you do. It\'s true that companies don\'t really pay attention to whether any given 401(k) investor owns their stock or not - but they do pay attention when there\'s downward pressure on their stock price, and when major institutions like banks, pension funds, and university endowments stop investing. The main impact on emissions of fossil free stock investing is the network effect of signaling to markets and governments that we must accelerate the net zero transition.'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Fossil fuel bonds'
            ),
            _react2.default.createElement(
              'p',
              null,
              'How are fossil fuel bonds different from fossil fuel stocks in terms of climate risk? If bonds are generally safer than stocks, how does climate change impact that?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Because they\'re considered lower risk, bonds tend to have lower returns than stocks - which is why between 60-80% of the money in any given 401(k) plan is invested in stocks. This partially explains why most of the focus of sustainable investing has been on stocks.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It\'s possible a bond might not be paid off if the company goes out of business. But generally, all things being equal, a fossil fuel bond is a safer investment than a fossil fuel stock. Because of that, and because the average 401(k) plan has 10 times more invested in fossil fuel stocks than fossil fuel bonds, an individual\'s investment risk may be higher with fossil fuel stocks.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The flip side of this is that since bond prices are less volatile and returns more similar across issuers, it reduces the friction to replacing fossil fuel bonds from similar bonds from other institutions.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'While risk to portfolio might be lower, risk to climate is not. If the impact on the climate from a stock is diffuse, the impact from a bond is direct. Bond issuances are one of the main ways fossil fuel companies raise capital to expand operations. The International Energy Agency has warned that there can be no new coal, oil, and gas development if humanity wants to prevent dangerous warming. If there are fossil fuel bonds in your 401(k), you\'re effectively lending your retirement savings to companies so they can mine for coal and drill for oil.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In this way, you\'re funding operations that are generating higher emissions and thus contributing to the higher risks faced by the entire portfolio from climate change.'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Reducing climate risk'
            ),
            _react2.default.createElement(
              'p',
              null,
              'What does this mean for retirement plans? If a company fails to properly manage climate risk in its retirement plan, it could constitute a failure of its fiduciary duty to manage the plan in the best interest of plan participants and beneficiaries. As New York Comptroller Thomas DiNapoli explained when announcing the state\u2019s plan to enforce a carbon-neutrality mandate, \u201Cinvesting for the low-carbon future is essential to protect the fund\u2019s long-term value.\u201D At least one employer has already faced lawsuits from an employee who claimed his pension fund did not adequately disclose or assess the effect of climate change on its investments.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The best way for retirement plans to protect their employees from climate risk is to make sure they have access to sustainable investments, and then to make sure the default investment option is considering climate risk factors. They should also engage the asset managers responsible for the fund portfolios. If asset managers aren\'t providing appropriate bond fund options that reduce exposure to climate-risky fossil fuel corporate bonds, companies should let them know that their employees deserve climate-safe investments.'
            ),
            _react2.default.createElement(
              'h2',
              null,
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.fossilFuelBondsIn401ks,
                  title: 'Fossil Fuel Bonds in 401(k)s',
                  xstrong: true
                },
                'See more on fossil fuel bonds in 401(k)s',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        ),
        _react2.default.createElement(_components.RiskTypeLinks, null),
        _react2.default.createElement(_components.HomeEduCenter, null)
      );
    }
  }]);
  return FossilFuelBondRisks;
}(_react.Component)) || _class);
exports.default = FossilFuelBondRisks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FossilFuelBondRisks/FossilFuelBondRisks.js
// module id = 1477
// module chunks = 0